import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
} from 'chart.js';
import 'chartjs-adapter-date-fns';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  TimeScale,
  Legend,
);

ChartJS.defaults.font.family =
  'SeekSans, "SeekSans Fallback", Arial, Tahoma, sans-serif';

// chartjs-plugin-zoom breaks in SSR, so we need to lazy load it
// But we need to register it before creating a chart, otherwise it skips the plugin
export const chartjsReady = new Promise<void>((resolve) => {
  if (typeof window === 'undefined') {
    return resolve();
  }

  import('chartjs-plugin-zoom')
    .then(({ default: zoomPlugin }) => {
      ChartJS.register(zoomPlugin);
      resolve();
    })
    .catch(() => {
      resolve();
    });
});
